var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-container"},[_c('VuePdfEmbed',{attrs:{"source":_vm.source},on:{"loaded":function($event){return _vm.$emit('loaded')},"loading-failed":function($event){return _vm.$emit('loading-failed')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }